export function IsLogin() {
    const user_data = localStorage.getItem("user_data");
    return user_data ? true : false;
}
export function IsVendor() {
    const user_data = JSON.parse(localStorage.getItem("user_data"));
    return user_data && user_data["is_vendor"] ? true : false;
}
